export const initialState = {
  /**
   * Auth.
   */
  auth: {
    token: null,
    user: null
  },

  /**
   * Cached objects.
   */
  cache: {
    //order: null,
  },

  /**
   * Local configuration.
   * @see /src/Config.js
   */
  clientConfig: null,

  /**
   * Environment variables.
   */
  envVars: null,

  /**
   * Zones, regions...
   */
  geography: {},

  /**
   * List of items (stores, departments...)
   */
  list: {},

  /**
   * Users permissions.
   */
  permissions: {},
  roles: {},

  /**
   * Configuration data from server.
   */
  serverConfig: null,

  /**
   * User preferences.
   */
  settings: {
    language: 'en',
  },

  system: {
    loading: {}
  }
}